import { Center, Spinner } from '@cardboard-ui/react';
import React, { PropsWithChildren, Suspense } from 'react';

export const SuspendWithRelativelyCenteredSpinner: React.FC<
  PropsWithChildren
> = (props) => {
  return <Suspense fallback={<RelativelyCenteredSpinner />} {...props} />;
};

export const RelativelyCenteredSpinner = () => (
  <Center h="100%" w="100%">
    <Spinner />
  </Center>
);
